import { FC } from 'react';
import styles from './PunchupDivider.module.css';

const PunchupDivider: FC = () => <hr className={styles.divider} />;

export { PunchupDivider };
